__turbopack_context__.v({
  "content": "member-module__YtKw9W__content",
  "member": "member-module__YtKw9W__member",
  "picture": "member-module__YtKw9W__picture",
});
